// Validate before Sentry parses/logs a malformed DSN. Never print its value.
export function isValidSentryDsn(value) {
  if (typeof value !== 'string' || !value.trim()) return false;
  try {
    const url = new URL(value.trim());
    return ['https:', 'http:'].includes(url.protocol) &&
      /^\w+$/.test(url.username) && (!url.password || /^\w+$/.test(url.password)) &&
      /^[\w.-]+$/.test(url.hostname) && /\/\d+$/.test(url.pathname) &&
      !url.search && !url.hash;
  } catch { return false; }
}

export function initializeOptionalSentry(dsn, initialize) {
  if (!dsn) return false;
  if (!isValidSentryDsn(dsn)) {
    console.warn('Error reporting disabled: invalid Sentry configuration.');
    return false;
  }
  try { initialize(dsn.trim()); return true; }
  catch {
    console.warn('Error reporting unavailable; the application will continue.');
    return false;
  }
}
